export function handleGenericError(response) {
  console.log(response);
}

export function handle420() {
  const history = window.__APP_HISTORY;

  if (history) {
    history.push('/login');
  }
}

export function handleErrorCause(error) {
  if (error.cause) {
    switch (error.cause.status) {
      case 420:
        handle420();
        break;
      default:
        throw error;
    }
  }
  throw error;
}
